import { Column, Row } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { Input } from 'app/design/primitives/input';
import { RemoteError } from 'app/design/primitives/remote-error';
import { useScopedTranslation } from 'app/hooks/i18n';
import type { CouponEditorProps } from './coupon-editor';
export function CouponEditor({
  coupon,
  error,
  onApply,
  onChange,
  onClear,
  value,
  disabled = false,
  isPending = false,
}: CouponEditorProps) {
  const { t } = useScopedTranslation();
  return (
    <Column gap="spacing.general.x2">
      <Row alignItems="flex-end" gap="spacing.general.x2">
        <Column flex={1}>
          <Input
            autoCapitalize="characters"
            editable={!disabled}
            label={t('couponFieldPlaceholder', { ns: 'payment' })}
            onChangeText={onChange}
            value={value}
          />
        </Column>
        <Button disabled={!value || value === coupon || isPending || disabled} onPress={onApply} variant="primary">
          {t('couponButton', { ns: 'payment' })}
        </Button>
      </Row>
      {coupon ? (
        <Button disabled={disabled} onPress={onClear} variant="secondary">
          {t('web.removeCoupon', { ns: 'payment' })}
        </Button>
      ) : null}
      {error ? <RemoteError message={error} /> : null}
    </Column>
  );
}
